/* eslint-disable @typescript-eslint/no-explicit-any */

import { ResponseSessionInfoGuarantee, SessionInfoResponseGuarantee } from "@interfaces/SecondGuarantee";
import { baseSecondGuaranteApi } from "./baseSecondGuaranteeApis";


const sessionGuaranteeApi = baseSecondGuaranteApi.injectEndpoints({
  endpoints: (build) => ({
    getSessionInfoGuarantee: build.query<SessionInfoResponseGuarantee, { id: string }>({
      query: ({ id }) => ({
        url: `/session_info/aval_adicional?sso_id=${id}`,
        method: "GET",
      }),
      transformResponse: (response: ResponseSessionInfoGuarantee) => {
        return response.data;
      },
    }),
  }),
});

export const { useLazyGetSessionInfoGuaranteeQuery } = sessionGuaranteeApi;